import {
  ClassListItem,
  CourseListItem,
  EntityListEnum,
  GetMetricsResponse,
  ProductDTO,
  SchoolListItem,
  UserListItem
} from "@beable/roster-backend-client-v1";
import RosterBackendService from "./RosterBackendService";

async function getMetrics(siteId: number, customerId: string): Promise<GetMetricsResponse | null> {  
  const response = await RosterBackendService.metricsGetAll(siteId, customerId);
  if (response.isOk()) {
      return response.value;
  } else {
      return null;
  }
}

async function getEntityData(
  siteId: number,
  entity: EntityListEnum,
  fromRow?: number,
  toRow?: number
): Promise<SchoolListItem[] | CourseListItem[] | ClassListItem[] | UserListItem[] | ProductDTO[] | null> {
  const response = await RosterBackendService.metricsGetListForEntity(siteId, entity, fromRow, toRow);
  if (response.isOk()) {
      return response.value;
  } else {
      return null;
  }
}

export default { getMetrics, getEntityData };
